export default __webpack_public_path__ + "/assets/vivi-video-lg.jpg";